<template>
  <v-app style="background-color:#ffcb0b">
    <v-main>
      <HelloWorld/>
    </v-main>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
@font-face {
  font-family: poppinsmedium;
  src: url("./assets/fonts/Poppins-Medium.ttf")
}
</style>